$(document).ready(function () {
  $(".header-desktop-search-button").click(function () {
    if (
      $(".site-header-search-container").hasClass(
        "site-header-search-container-active"
      )
    ) {
      $(".site-header-search-container").removeClass(
        "site-header-search-container-active"
      );
      $("body").removeClass("bg-overlay");
    } else {
      $(".site-header-search-container").addClass(
        "site-header-search-container-active"
      );
      $("body").addClass("bg-overlay");
    }
  });
  $("#close-search-button").click(function () {
    $(".site-header-search-container").removeClass(
      "site-header-search-container-active"
    );
    $("body").removeClass("bg-overlay");
  });


  // range filter for price
  const allRanges = document.querySelectorAll(".col_price_filters");
  if (allRanges.length) {
  allRanges.forEach((wrap) => {
    const range = wrap.querySelector(".collection-filters__filter-range-input");
    const bubble = wrap.querySelector(".bubble");

    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);
  });

  function setBubble(range, bubble) {
    const val = range.value;
    const min = range.min ? range.min : 0;
    const max = range.max ? range.max : 100;
    const newVal = Number(((val - min) * 100) / (max - min));
    bubble.innerHTML = val;
  }

  const rangeMin = document.querySelector(".collection-filters__filter-range--from input");
    const rangeMax = document.querySelector(".collection-filters__filter-range--to input");
    const minValue = document.querySelector(".collection-filters__filter-range--from .bubble");
    const maxValue = document.querySelector(".collection-filters__filter-range--to .bubble");
    const sliderTrack = document.querySelector(".slider-track");
    const minGap = 1;
    const sliderMaxValue = parseInt(rangeMax.max);

    function fillColor() {
      let percent1 = (parseInt(rangeMin.value) / sliderMaxValue) * 100;
      let percent2 = (parseInt(rangeMax.value) / sliderMaxValue) * 100;
      sliderTrack.style.background = `linear-gradient(to right, #E8EEDB ${percent1}% , #A5251C ${percent1}% , #A5251C ${percent2}%, #E8EEDB ${percent2}%)`;
    }

    function updateRange(event) {
      let minVal = parseInt(rangeMin.value);
      let maxVal = parseInt(rangeMax.value);
      
      if (maxVal - minVal < minGap) {
        if (event.target === rangeMin) {
          rangeMin.value = maxVal - minGap;
        } else {
          rangeMax.value = minVal + minGap;
        }
      }
      
      minValue.textContent = rangeMin.value;
      maxValue.textContent = rangeMax.value;
      fillColor();
    }

    rangeMin.addEventListener("input", updateRange);
    rangeMax.addEventListener("input", updateRange);
    fillColor();
  }
  

// Remove Text from Frequently Bought Together App Section
function handleTextRemoval() {
    function removeFirstTextNode() {
        document.querySelectorAll('.ctm_main_pdpd label[data-product-handle]').forEach(element => {
            if (element.firstChild && element.firstChild.nodeType === Node.TEXT_NODE) {
                element.firstChild.remove();
            }
        });
    }

    const interval = setInterval(() => {
        requestAnimationFrame(removeFirstTextNode);
    }, 500);

    const observer = new MutationObserver((mutations, obs) => {
        mutations.forEach(mutation => {
            if (mutation.type === 'childList') {
                removeFirstTextNode();
                if (!document.querySelector('.ctm_main_pdpd label[data-product-handle]')?.firstChild?.nodeType === Node.TEXT_NODE) {
                    clearInterval(interval);
                    obs.disconnect();
                }
            }
        });
    });

    requestAnimationFrame(() => {
        if (document.body) {
            observer.observe(document.body, { childList: true, subtree: true });
            removeFirstTextNode();
        }
    });
}

handleTextRemoval();

  });

